<template>
  <v-card
      v-if="!isEmpty(frameworkEntity)"
      flat column>
    <v-subheader>
      Enquadramento
    </v-subheader>
    <v-card
        flat
        class="ml-3 px-4 py-2"
        color="grey lighten-5">
      <v-layout column>
        <span>
          {{ frameworkEntity.typology.code }} - {{ frameworkEntity.typology.name }}
        </span>
        <span v-for="(tpf, index) in technicalParametersFilled" :key="index">
          {{ tpf.name }}: {{ tpf.value }}
        </span>
        <span>
          {{ frameworkEntity.degradingPotentialParameterName }}: {{ frameworkEntity.degradingPotentialForTax.name }}
        </span>
        <span>
          {{ frameworkEntity.sizeParameterName }}: {{ frameworkEntity.sizeForTax.name }}
        </span>
      </v-layout>
    </v-card>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  name: 'ResumeFramework',
  data() {
    return {
      isEmpty,
    }
  },
  computed: {
    ...mapGetters('newApplication', ['newApplication']),
    frameworkEntity() {
      return this.newApplication.frameworkEntity;
    },
    technicalParametersFilled(){
      return this.frameworkEntity.technicalParametersFilled;
    }
  },
};
</script>
